export default {
    data() {
        return {
            isOtpApiCalled: false,
            otpSent: false, // Added variable to track OTP sent status
            isDisabled: true,
            resendOtp: false,
            timerRunning: false,
            minutes: 5,
            seconds: 0,
            passwordFieldType: 'password',
            confPasswordFieldType: 'password',
            // init: false,
            loadingOtp: false,
            getOTPmsg:false,
            loginMethod: 'password',
            contIndex :  this.countryCodeList?.findIndex(ci => ci.phonecode == this.$siteSettings.data.country_code)

        }
    },
    methods: {
        setUserIdsToStore(userId) {
            let oldUserIds = this.$store.getters?.logInData?.userIds || [];
            if(this.form.type === 2) {
                if(this.$auth?.user?.last_login_at){
                    oldUserIds.push(userId);
                }
                let data = {
                    logInWithMobile: false,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
            else {
                let data = {
                    logInWithMobile: true,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
        },
        refreshData() {
            this.form = {
                code: this.$siteSettings.data && this.$siteSettings.data.country_code ? this.$siteSettings.data.country_code : "91",
                mobileNo: "",
                otp: '',
                userName: '',
                userId: '',
                password: "",
                confirmPassword: "",
                type: this.$siteSettings?.data?.business_type == 2 ? 1 : 2,
            },
                this.isRefral=false,
                this.isOtpApiCalled = false,
                this.resendOtp = false,
                this.resendOtpTimer = 0,
                this.timerRunning = false,
                this.minutes = 0,
                this.seconds = 0,
                this.otpSent = false,
                this.passwordFieldType = 'password',
                this.confPasswordFieldType = 'password',
                this.LoginInit = false,
                this.isSetUserId= false;
                this.isRefral= false
                this.hasUrlReferer= false,
                this.getOTPmsg= false,
                this.loginMethod= 'password',
                this.showValidationError = false;
                this.oldPassword = ''; 
                this.newPassword = '';
                this.confirmPassword = '';
                this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.$siteSettings.data.country_code)
                this.init = false

        },
        sendOtpCall(auth_type) {
            if (this.form.mobileNo) {
                this.loadingOtp = true;
                this.sendOtpServiceCall(auth_type);
            }else{
                this.LoginInit = true;
            }
        },
        sendOtpServiceCall(auth_type) {
            this.loadingOtp = true;
            let data = {
                type: auth_type,
                mobile: this.form.mobileNo, 
                countrycode: this.form.code
            }
            this.$apiCall('post', 'SEND_OTP', data).then(response => {
                this.loadingOtp = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response?.data?.error) {
                            this.$errorToast(response?.data?.error);
                        }
                        else{
                            this.isOtpApiCalled = true;
                            this.otpSent = true; // OTP sent successfully, disable phone number field
                            this.isDisabled = false;
                            this.$successToast(response.data.data)
                            this.resendOtp = true;
                            this.timerRunning = true;
                            this.minutes = 5;
                            this.seconds = 0;
                            this.setResendTimer();
                            this.getOTPmsg = false;
                        }
                    }
                }
            }).catch(error => {
                this.getOTPmsg = false;
                this.loadingOtp = false;
                if (error)
                    this.$errorToast(error[0])
            });
        },
        getOtp() {
            return this.form.otp.toString();
        },
        togglePasswordVisibility(fieldName) {
            this[fieldName] = this[fieldName] === 'password' ? 'text' : 'password';
        },
        setResendTimer() {

            const countdown = () => {
                if (this.minutes === 0 && this.seconds === 0) {
                    this.timerRunning = false;
                    // Timer has expired, you can perform any action here
                } else {
                    if (this.seconds === 0) {
                        this.minutes--;
                        this.seconds = 59;
                    } else {
                        this.seconds--;
                    }
                    setTimeout(countdown, 1000);
                }
            };

            setTimeout(countdown, 1000);
        },
        formatTime(value) {
            return value < 10 ? `0${value}` : value;
        },
    }
}